import { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from './Auth.jsx';
import LoadingVisualization from './LoadingVisualization';

/**
 * RootRedirect component handles the root route '/' by redirecting users
 * based on their authentication state:
 * - Authenticated users → /chat
 * - Unauthenticated users → /login
 */
function RootRedirect() {
  const { user, loading } = useContext(UserContext);

  // Show loading while authentication state is being determined
  if (loading) {
    return <LoadingVisualization />;
  }

  // Redirect based on authentication state
  if (user) {
    // User is authenticated, redirect to chat
    return <Navigate to="/chat" replace />;
  } else {
    // User is not authenticated, redirect to login
    return <Navigate to="/login" replace />;
  }
}

export default RootRedirect;
